import React from "react";
import { EmptyStateLogoOption1 } from "../loan-list/logos/empty-state-logo-option1";

export const EmptyTabComponent = ({
    title,
    description,
    children,
}) => {
  return (
    <div className='flex flex-1 items-center justify-center bg-primary-7'>
      <div className='flex flex-col items-center gap-8'>
        <EmptyStateLogoOption1 />
        <div>
          <p className='font-semibold text-3xl text-neutral-10 mb-4 mx-auto'>
            {title}
          </p>
          {description && <p className='font-light text-center text-base text-neutral-8 max-w-md mx-auto'>
            {description}
          </p>}
        </div>
        {children}
      </div>
    </div>
  );
};